'use client';

import {
  ReactNode,
  AnchorHTMLAttributes,
  forwardRef,
} from 'react';
import useIsIframe from '../../hooks/use-is-iframe';
import { useOverwolfApi } from '../../hooks/use-overwolf-api';

interface OWLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
}

const OWLink = forwardRef<HTMLAnchorElement, OWLinkProps>(({
  href,
  children,
  target,
  rel,
  ...rest
}, ref) => {
  const isIframe = useIsIframe();
  const { isAvailable: isOverwolf } = useOverwolfApi();

  // When embedded in an iframe we normally break links out into a new tab.
  // But when running inside the Overwolf app, navigation should stay within
  // the iframe instead of being kicked out to the external browser.
  const finalTarget = isIframe && !isOverwolf ? '_blank' : target;
  const secureRel =
    finalTarget === '_blank' && !rel ? 'noopener noreferrer' : rel;

  return (
    <a
      href={href}
      target={finalTarget}
      rel={secureRel}
      ref={ref}
      {...rest}
    >
      {children}
    </a>
  );

});

export default OWLink;
